import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "textSecondary--text" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "LeasePeriodListItem__footer d-flex d-sm-block align-center-sm" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "d-flex align-center mt-sm-3 ml-3 ml-sm-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RcCalendarIcon = _resolveComponent("RcCalendarIcon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_RcFemaleIcon = _resolveComponent("RcFemaleIcon")!
  const _component_RcMaleIcon = _resolveComponent("RcMaleIcon")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    "no-gutters": "",
    class: "LeasePeriodListItem role"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        class: "py-4 px-4 px-sm-6 pb-0 pb-sm-4",
        cols: "12",
        sm: "7",
        md: "8",
        lg: "9"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.leasePeriod.name), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_RcCalendarIcon, { style: {"padding-top":"-10px"} }),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.convertDate(_ctx.leasePeriod.start_date)) + " - " + _toDisplayString(_ctx.convertDate(_ctx.leasePeriod.end_date)), 1)
          ]),
          (_ctx.leasePeriod.description)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "LeasePeriodListItem__divider" }, null, -1)),
                _createElementVNode("p", {
                  class: "textSecondary--text",
                  innerHTML: _ctx.leasePeriod.description
                }, null, 8, _hoisted_3)
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_v_divider, { class: "my-3 d-sm-none" })
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        class: "LeasePeriodListItem__actions py-4 py-sm-8 px-4 px-sm-6 pt-0 pt-sm-4",
        cols: "12",
        sm: "5",
        md: "4",
        lg: "3"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_btn, {
              class: "flex-grow-1 text-left text-capitalize",
              color: "primary",
              style: {"width":"200px"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('apply', _ctx.leasePeriod.id)))
            }, {
              default: _withCtx(() => [
                (_ctx.leasePeriod.open_to_renewals)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Open to Renewals"))
                  : (_ctx.leasePeriod.allow_same_bed_renewals)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Same Bed Renewals"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, "Apply Now")),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "flex-grow-1" }, null, -1)),
                _createVNode(_component_v_icon, { end: "" }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" chevron_right ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.leasePeriod.genders_available.includes('F'))
                ? (_openBlock(), _createBlock(_component_RcFemaleIcon, {
                    key: 0,
                    class: "mr-3"
                  }))
                : _createCommentVNode("", true),
              (_ctx.leasePeriod.genders_available.includes('M'))
                ? (_openBlock(), _createBlock(_component_RcMaleIcon, { key: 1 }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}